export type GaEventParams = Record<string, string | number | boolean | null | undefined>;

type GtagFn = (command: 'event', eventName: string, params?: Record<string, unknown>) => void;

declare global {
  var gtag: GtagFn | undefined;
}

function getGtag(): GtagFn | undefined {
  const candidate = globalThis.gtag;
  return typeof candidate === 'function' ? candidate : undefined;
}

export function sendGaEvent(eventName: string, params: GaEventParams): boolean {
  const gtag = getGtag();
  if (!gtag) return false;

  const filtered = Object.fromEntries(Object.entries(params).filter(([, value]) => value != null));
  gtag('event', eventName, filtered);
  return true;
}
